// src/utils/csrf.js

const DEFAULT_CSRF_COOKIE = "csrftoken";

/**
 * Retorna o valor bruto de um cookie a partir do nome.
 */
export function getCookie(name) {
  if (typeof document === "undefined") return null;

  const cookies = document.cookie ? document.cookie.split(";") : [];
  for (let cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(`${name}=`)) {
      return decodeURIComponent(trimmed.substring(name.length + 1));
    }
  }
  return null;
}

/**
 * Recupera o token CSRF a partir do cookie padrão (ou customizado via parâmetro).
 */
export function getCsrfToken(cookieName = DEFAULT_CSRF_COOKIE) {
  return getCookie(cookieName);
}

const SAFE_METHODS = new Set(["GET", "HEAD", "OPTIONS", "TRACE"]);

export function shouldSendCsrf(method) {
  if (!method) return false;
  return !SAFE_METHODS.has(String(method).toUpperCase());
}

/**
 * Garante que o header X-CSRFToken está presente quando necessário.
 */
export function appendCsrfHeader(headers = {}, method, cookieName) {
  if (!shouldSendCsrf(method)) return headers;

  const csrfToken = getCsrfToken(cookieName);
  if (csrfToken && !headers["X-CSRFToken"]) {
    headers["X-CSRFToken"] = csrfToken;
  }
  return headers;
}

export const CSRF_COOKIE_NAME = DEFAULT_CSRF_COOKIE;
